import {
  BasicButton,
  DangerButton,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  Modal,
  Text,
} from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isConfirmLoading?: boolean;
}

export function ManualIdvDeclineConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  isConfirmLoading,
}: Props) {
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} testID="manual-idv-decline-confirmation-modal">
      <Dialog>
        <DialogHeader onClose={onClose}>
          {t("Cancel identity verification?")}
        </DialogHeader>
        <DialogContent>
          <Text style="global/body-primary">
            {t("This will cancel the DBS check for this applicant.")}
          </Text>
        </DialogContent>
        <DialogFooter>
          <BasicButton onPress={onClose} testID="manual-idv-decline-go-back">
            {t("Go back")}
          </BasicButton>
          <DangerButton
            onPress={onConfirm}
            isLoading={isConfirmLoading}
            testID="manual-idv-decline-confirm"
          >
            {t("Cancel verification")}
          </DangerButton>
        </DialogFooter>
      </Dialog>
    </Modal>
  );
}
